import { Component } from '@angular/core';

@Component({
  selector: 'app-celebrity-by-domain-skeleton',
  templateUrl: './celebrity-by-domain-skeleton.component.html',
  styleUrl: './celebrity-by-domain-skeleton.component.scss',
  standalone: true
})
export class CelebrityByDomainSkeletonComponent {
  constructor() { }
}
